import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of, map, switchMap, catchError } from 'rxjs';
import * as ActionConfigurationManager from '.././_actions/config.actions';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { s3ManagementService } from '../_services/s3-management.service';
import { s3UploadFailure, s3UploadSuccess } from '../_actions/s3-management.action';

@Injectable()
export class S3ManagementEffects {

  public s3Upload$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionConfigurationManager.S3_UPLOAD_DOCUMENTS),
      switchMap((action: any) => this.s3ManagementService
        .s3Upload(action.brandName, action.fileToUpload, action.vin)
        .pipe(
          map((response: any) => {
            const hasData = response && Array.isArray(response.data) && response.data.length > 0;
            if (hasData) {
              return s3UploadSuccess(response);
            }
            return s3UploadFailure(response || { success: false });
          }),
          // `status` and the response body are forwarded so the modal can tell an oversized
          // or rejected file apart from a general upload failure.
          catchError((error) => of(s3UploadFailure({
            success: false,
            status: error?.status ?? 0,
            error: error?.error ?? null,
            message: error?.message || 'upload_failed'
          })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private s3ManagementService: s3ManagementService
  ) {}
}
